
        import '/home/builduser/work/97f164ade279074e/santa-editor/packages/rEditor/rootComps/newReleasesFeed/newReleasesFeed.scss.css.virtualfile';
        module.exports = {"container":"_container_1an6l_7"};